var React = require('react');
import { Link } from 'react-router-dom';
import {USE_HOSTNAME} from './constants';
import { LoginUser } from './utils'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Username: '',
            Password: '',
            errors: {}
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.validate()) {
            LoginUser(this.state.Username, this.state.Password)
        }
        else {
            alert("Missing required information, see form.")
        }
        
    }


    validate() {
        let input = this.state;
        let errors = {};
        let isValid = true;

        /*if (typeof input['Email'] !== 'undefined') {

            var emailPattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!emailPattern.test(input['Email'])) {
                isValid = false;
                errors['Email'] = "Valid Email address not entered.";
            }
        }*/

        if (!input['Password']) {
            isValid = false;
            errors['Password'] = "Password field required";
        }

        this.setState({
            errors: errors
        })

        console.log(errors);

        return isValid;
    }



    render() {
        return (
        <Box>
                <div className='DivLogin'>
                    <Typography component="h1" variant="h5" className='HeadLogin'>Login</Typography>
                    <form className='FormLogin' onSubmit={this.handleSubmit}>

                        <label>Username: </label>
                        <TextField style={{ borderRadius: '50', backgroundColor: "white" }} type="text" name="Username" className='InputProfileCreate' value={this.state.Username} onChange={this.handleChange}/><br />

                        <label>Password:</label>
                        <TextField style={{ borderRadius: '50', backgroundColor: "white" }} type="Password" name="Password" className='InputProfileCreate' value={this.state.Password} onChange={this.handleChange}/><br />

                        <Button style={{ borderRadius: '50', backgroundColor: "white" }}  variant="outlined" className='ButtonLogin' type='submit' value='Submit' sx={{ mt: 3, mb: 2 }} >Login</Button><br />
                    </form>
            </div>
        </Box>
                )
    };
};

export default Login;